import { render } from "./FeaturedVideos.vue?vue&type=template&id=431f442d"
import script from "./FeaturedVideos.vue?vue&type=script&lang=js"
export * from "./FeaturedVideos.vue?vue&type=script&lang=js"
script.render = render

export default script